import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-side-list-item',
    templateUrl: './side-list-item.component.html',
    styleUrls: ['./side-list-item.component.scss'],
})
export class SideListItemComponent {
    @Input()
    public text: string;
    @Input()
    public icon: string;

    constructor() {}
}
